export const attachmentsPath = '/attachments';

export const rootFolder = {
  id: null,
  name: 'All Files',
};

export const excludedColumns = [
  'createdBy',
  'lastAccessed',
  'owner',
  'select',
  'size',
];

export const fileSystemAttributeOverrides = {
  actions: {
    className: 'actions',
    label: 'Actions',
  },
  lastModified: {
    className: 'date-column',
    label: 'Uploaded at',
    padded: false,
  },
  name: {
    width: '',
  },
};

export const fileSystemAdditionalColumns = [
  {
    className: 'user-column',
    key: 'uploadedBy',
    label: 'Uploaded by',
  },
];
